//FulfillmentScreenIds + PostPlacementScreenIds merged into ScreenId
var ScreenId;
(function (ScreenId) {
    ScreenId["none"] = "none";
    // Fulfillment
    ScreenId["fullFillmentTicketSystem"] = "full-fulfillment-ticket-system";
    ScreenId["loadVerification"] = "load-verification";
    ScreenId["loadVerificationAdmin"] = "verification-admin";
    ScreenId["loadFulfillment"] = "load-fulfillment";
    ScreenId["assuredLoads"] = "load-assured-list";
    ScreenId["bidsWithDepositLead"] = "bids-with-deposit-lead";
    // Post Placement
    ScreenId["ppTicketSystem"] = "post-placement-ticket-system";
    ScreenId["ppAllLoad"] = "pp-all-load";
    ScreenId["ppPlacement"] = "pp-placement";
    ScreenId["ppLoading"] = "pp-loading";
    ScreenId["ppUnloading"] = "pp-unloading";
    ScreenId["ppCompleted"] = "pp-completed";
    ScreenId["ppCancelled"] = "pp-cancelled";
    // Others
    ScreenId["executives"] = "executives";
    ScreenId["allUsers"] = "all-users";
    ScreenId["userRoles"] = "user-roles";
    ScreenId["userAttendance"] = "cs-attendance";
    ScreenId["agentStatus"] = "agent-status";
    ScreenId["admin"] = "admin";
    ScreenId["customer"] = "customer";
    ScreenId["trackScreen"] = "track-screen";
    ScreenId["ticketSystem"] = "ticket-system";
    ScreenId["tsm"] = "tsm";
    ScreenId["loadEnquiryCards"] = "load-enquiry-cards";
    ScreenId["lorryEnquiryCards"] = "lorry-enquiry-cards";
    ScreenId["customerProfile"] = "customer-profile";
    ScreenId["customerLorries"] = "customer-lorries";
    ScreenId["customerMarketplace"] = "customer-marketplace";
    ScreenId["myLoads"] = "myloads";
    ScreenId["myLorries"] = "mylorries";
    ScreenId["bulkLoad"] = "bulk-load";
    ScreenId["paymentList"] = "payment-list";
    ScreenId["aadhaarVerification"] = "aadhaar-verification";
    ScreenId["panVerification"] = "pan-verification";
    ScreenId["ewayVerification"] = "eway-verification";
    ScreenId["businessVerification"] = "business-verification";
    ScreenId["rcVerification"] = "rc-verification";
    ScreenId["callMeBack"] = "call-me-back";
    ScreenId["membershipCallMeBack"] = "membership-call-me-back";
    ScreenId["loadPostSupport"] = "load-post-support";
    ScreenId["intransitCallMeBack"] = "intransit-call-me-back";
    ScreenId["refundRequest"] = "refund-request";
    ScreenId["cashbackStatus"] = "cashback-status";
    ScreenId["bidCancellation"] = "bid-cancellation";
    ScreenId["sendWhatsappMsg"] = "send-whatsapp-msg";
    ScreenId["blockUsers"] = "block-users";
    ScreenId["companyRegistrationLeads"] = "company-registration-leads";
    ScreenId["adsLeads"] = "ads-leads";
    ScreenId["companyDlVerification"] = "company-dl-verification";
    //TSO Common
    ScreenId["myReferrals"] = "my-referrals";
    ScreenId["newReferrals"] = "new-referrals";
    ScreenId["bulkTagging"] = "bulk-tagging";
    //TSO Load
    ScreenId["tsoLoadUser"] = "tsoLoadUser";
    ScreenId["tsoActiveLoadsPage"] = "tsoActiveLoadsPage";
    ScreenId["tsoInTransitLoadPage"] = "tsoInTransitLoadPage";
    ScreenId["tsoLoadEnquiryCard"] = "tsoLoadEnquiryCard";
    ScreenId["tsoLoadMarketPlace"] = "tso-load-marketplace";
    //TSO Lorry
    ScreenId["tsoLorryUser"] = "tsoLorryUser";
    ScreenId["tsoActiveLorryPage"] = "tsoActiveLorryPage";
    ScreenId["tsoInTransitLorryPage"] = "tsoInTransitLorryPage";
    ScreenId["tsoLorryEnquiryCard"] = "tsoLorryEnquiryCard";
    ScreenId["tsoLorryMarketPlace"] = "tso-lorry-marketplace";
    ScreenId["assuredAndSpotLoads"] = "assured-and-spot-loads";
    // Ticket System
    ScreenId["vasLeads"] = "vas-leads";
    ScreenId["help"] = "help";
    ScreenId["accountDeletion"] = "account-deletion";
    //Report groups
    ScreenId["reportSystem"] = "reportSystem";
    ScreenId["membershipReportSystem"] = "membershipReportSystem";
    ScreenId["cargoInsuranceReportSystem"] = "cargoInsuranceReportSystem";
    ScreenId["realTimeTransaction"] = "realTimeTransaction";
    ScreenId["tapNGoDepositRecord"] = "tapNGoDepositRecord";
    ScreenId["membershipPurchasedRecord"] = "membershipPurchasedRecord";
    ScreenId["membershipLead"] = "membershipLead";
    ScreenId["membershipLeadHistory"] = "membershipLeadHistory";
    ScreenId["cargoInsuranceLead"] = "cargoInsuranceLead";
    ScreenId["cargoInsuranceLeadHistory"] = "cargoInsuranceLeadHistory";
    // TSO New Screen
    ScreenId["tsoLeadSubmit"] = "tso-lead-submit";
    ScreenId["tsoLeadHistory"] = "tso-lead-history";
    ScreenId["tsoMyTaggedUser"] = "tso-my-tagged-users";
    // TSO new Screen For Admin
    ScreenId["tsoAdminScreens"] = "tso-admin";
    ScreenId["tsoAdminSessionsPage"] = "tso-admin-sessions";
    ScreenId["tsoAdminLeadsPage"] = "tso-admin-leads";
    ScreenId["tsoAdminLeadsDetailPage"] = "tso-admin-leads-details";
})(ScreenId || (ScreenId = {}));
/** Display names for Post Placement ticket screens (nav / page titles). */
const ScreenNameMap = {
    [ScreenId.ppAllLoad]: "PP All Loads",
    [ScreenId.ppPlacement]: "PP Placement",
    [ScreenId.ppLoading]: "PP Loading",
    [ScreenId.ppUnloading]: "PP Unloading",
    [ScreenId.ppCompleted]: "PP Completed",
    [ScreenId.ppCancelled]: "PP Cancelled"
};

export { ScreenId, ScreenNameMap };
//# sourceMappingURL=screenId.js.map
